import React from 'react';
import { Dialog, DialogContent, DialogTitle, makeStyles, TableBody, TableCell, TableRow } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import Table from '../../components/Table/Table';

const useStyles = makeStyles((theme) => ({
  chartDialogTitle: {
    '& > .MuiTypography-root': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& svg': {
      cursor: 'pointer',
    },
  },
}));

const SponsorStatistics = (props) => {
  const { count, openChart, handleClose } = props;
  const classes = useStyles();

  return (
    <Dialog open={openChart} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="customized-dialog-title" className={classes.chartDialogTitle}>
        Sponsor 통계
        <CloseIcon onClick={handleClose} />
      </DialogTitle>
      <DialogContent dividers>
        <h3>구분</h3>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                온라인
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['online']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>오프라인</TableCell>
              <TableCell>{count['offline']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'}>프로그램 북 & 초록집 광고</TableCell>
              <TableCell>{count['advertisement']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <h3>신청내용</h3>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell rowSpan={2} component={'th'}>
                오프라인
              </TableCell>
              <TableCell>A Type</TableCell>
              <TableCell>{count['typeA']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>B Type</TableCell>
              <TableCell>{count['typeB']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell rowSpan={2} component={'th'}>
                온라인
              </TableCell>
              <TableCell>온라인 부스</TableCell>
              <TableCell>{count['onlineBooth']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>온라인 광고</TableCell>
              <TableCell>{count['onlineAdvertisement']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <h3>책자광고</h3>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                프로그램 북 표1
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['pb1']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                프로그램 북 표2
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['pb2']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                프로그램 북 표3
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['pb3']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                프로그램 북 표4
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['pb4']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                프로그램북 내지
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['pb5']}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} style={{ width: '300px' }}>
                초록집 내지
              </TableCell>
              <TableCell style={{ width: '100px' }}>{count['ebook']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default SponsorStatistics;
